
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2452',
  depVersions: {
  "customer-portal-app": "static-1.2452",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.473",
  "data-fetching-client": "static-1.9712",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25514",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5637",
  "hs-test-utils": "static-1.8062",
  "hub-http": "static-1.6269",
  "hub-http-shared-msw-handlers": "static-1.10076",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18362",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11520",
  "I18n": "static-7.1633",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6510",
  "payment-link-components": "static-1.23636",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7088",
  "quartz-core": "static-1.6307",
  "quartz-i18n": "static-1.763",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10255",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5381",
  "rich-text-lib": "static-1.19910",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18062",
  "ui-components-test-utils": "static-1.5657",
  "UIComponents": "static-3.8466",
  "foundations-assets": "static-1.4916",
  "foundations-components": "static-1.8021",
  "foundations-theming": "static-1.4466",
  "foundations-theming-specialty": "static-1.2182",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1000",
  "quartz-config": "static-1.866",
  "quartz-routing": "static-1.518",
  "quick-fetch": "static-1.3954",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fix-in-app-reporter-stuck-start-timestamp.5",
  "rpc-client-utils": "static-1.4699",
  "sanitize-text": "static-1.8189",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4809",
  "ui-addon-react-router-dom": "static-1.9588",
  "usage-tracker": "static-1.7396",
  "usage-tracker-anonymous": "static-1.5813",
  "usage-tracker-core": "static-1.7246",
  "video-components-external": "static-1.11445",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3436",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3365",
  "quartz-webpack": "static-1.3312",
  "bend-plugin-quartz-routing": "static-1.166",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7722",
  "frontend-preferences-client": "static-1.7973",
  "laboratory-lib": "static-3.7202",
  "onboarding-scopes": "static-1.6508",
  "seat-types-lib": "static-1.125",
  "ui-addon-opt": "static-4.8409",
  "HeadJS": "static-2.765",
  "hs-test-utils-bend-plugin": "static-1.3173",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.117",
  "ts-schema": "static-1.4117",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7821",
  "cssUtils": "static-1.802",
  "customer-data-ui-utilities": "static-1.9872",
  "HubStyle": "static-2.11827",
  "knowledge-content-types": "static-1.8511",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.488",
  "ui-addon-emoji-picker": "static-1.9933",
  "ui-addon-i18n": "static-1.11198",
  "ui-business-units-lib": "static-1.9104",
  "ui-shepherd-react": "static-3.10252",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4372",
  "commerce-tours-lib": "static-1.6188",
  "customer-data-properties": "static-1.51733",
  "getting-started-shared-tasks": "static-1.18560",
  "growth-onboarding-reliability": "static-1.5127",
  "onboarding-tours": "static-1.16692",
  "reference-resolvers-lite": "static-1.8142",
  "sales-checkout-service-client": "static-1.3688",
  "ui-addon-iframeable": "static-1.9106",
  "user-context": "static-1.5153",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.839",
  "hubspotter-http": "static-1.4688",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.539",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.763",
  "quartz-head": "static-1.753",
  "quartz-test": "static-1.763",
  "quartz-tracking": "static-1.467",
  "ui-fonts": "static-1.782",
  "usage-tracker-container": "static-1.7386",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9470",
  "data-token-picker": "static-1.16485",
  "FileManagerLib": "static-1.39385",
  "property-translator": "static-1.5445",
  "atom": "static-1.5121",
  "merchandise-lib": "static-1.265",
  "purchase-motions-components": "static-1.5998",
  "salesImages": "static-1.526",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5504",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1163",
  "bend-plugin-foundations-components": "static-1.4290",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.31",
  "trellis-assets": "static-1.2065",
  "bend-plugin-foundations-theming": "static-1.2949",
  "foundations-theming-base": "static-1.3451",
  "stylex": "static-1.34",
  "interframe": "static-3.4805",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5810",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.109",
  "chirp-fetch": "static-1.1934",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4522",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4698",
  "content-media-composition-data-lib": "static-1.12500",
  "content-media-compositions": "static-2.16507",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4200",
  "magpie-lib": "static-1.5581",
  "magpie-types": "static-1.5041",
  "media-bridge-lib": "static-1.19006",
  "video-data-lib": "static-1.35103",
  "bender-build-tools": "static-1.3227",
  "inbound-db-properties-service-client": "static-1.3883",
  "superstore": "static-1.4806",
  "feedback-loader": "static-1.29381",
  "ai-components-ui-library": "static-1.9087",
  "ui-addon-video-player": "static-1.8750",
  "ui-coaching-tips": "static-1.28692",
  "sassPrefix": "static-1.157",
  "react-dnd-compat": "static-1.4660",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2545",
  "navigation-messaging": "static-1.7485",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8218",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9737",
  "crm-message-bus": "static-1.43093",
  "growth-data-modal": "static-1.5499",
  "hubspot-apollo-client": "static-1.4925",
  "onboarding-tours-client": "static-1.4906",
  "calling-global-api": "static-1.64674",
  "calling-internal-common": "static-1.31350",
  "calling-lifecycle-internal": "static-1.66056",
  "calling-lifecycle-messages": "static-1.58350",
  "conditional-properties-service-client": "static-1.3834",
  "crm-links": "static-1.6350",
  "crm-pipelines-api-client-types": "static-1.4177",
  "customer-data-objects-ui-components": "static-1.13077",
  "customer-data-properties-shared-msw-handlers": "static-1.9403",
  "customer-data-property-utils": "static-1.8137",
  "external-options-client-types": "static-1.4195",
  "file-manager-components": "static-1.23745",
  "framework-data-schema-resolvers": "static-1.6934",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.211",
  "inbound-db-meta-service-client": "static-1.3623",
  "inbounddb-objects-service-types": "static-1.4260",
  "meetings-icalendar-utils-lib": "static-1.678",
  "multi-currency-client-types": "static-1.3728",
  "object-builder-ui-client": "static-1.48904",
  "pipeline-validation-client-types": "static-1.4003",
  "property-value-citations": "static-1.2347",
  "pulse": "static-1.630",
  "smart-property-lib": "static-1.7340",
  "tiered-pricing": "static-1.1321",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11036",
  "growth-onboarding-confetti": "static-1.3113",
  "growth-onboarding-next-action-utils": "static-1.2056",
  "navigation-components": "static-1.18158",
  "onboarding-tours-utils": "static-1.758",
  "ui-shepherd-tracker": "static-1.7633",
  "ui-universal-auth": "static-1.9034",
  "batch-promise": "static-1.1588",
  "getting-started-shared-tasks-store": "static-1.17678",
  "hubspotter-http-shared-msw-handlers": "static-1.10074",
  "usage-tracker-session-replay": "static-1.5082",
  "audio-components": "static-1.5984",
  "FileManagerCore": "static-1.39244",
  "FileManagerImages": "static-1.36896",
  "video-components": "static-1.13447",
  "foundations-components-legacy": "static-1.1046",
  "purchase-motions-api": "static-1.6001",
  "signup-constants": "static-1.18939",
  "signup-ui-url-generator": "static-2.8101",
  "usage-tracker-public": "static-1.7207",
  "reactive-lib": "static-1.770",
  "simple-logging-lib": "static-1.3097",
  "chatspot-core": "static-1.21489",
  "ContentUtils": "static-1.68503",
  "copilot-toolkit": "static-1.11257",
  "growth-onboarding-feedback-components": "static-1.6626",
  "commerce-permissions": "static-1.820",
  "customer-data-tracking": "static-1.6936",
  "products-iframe-lib": "static-1.8066",
  "products-ui-components-shared-msw-handlers": "static-1.10458",
  "restore-request-side-panel-lib": "static-1.1032",
  "onboarding-data-sync-lib": "static-1.2030",
  "hubspot-apollo-cache": "static-1.384",
  "calling-error-reporting": "static-1.31357",
  "shared-worker-versioning": "static-1.11082",
  "calling-usage-tracker": "static-1.6588",
  "self-service-api": "static-1.10293",
  "voice-sms-access-library": "static-1.1192",
  "conversations-skeleton-state": "static-1.7295",
  "location-customization-utils-lib": "static-1.9398",
  "fdsr-migration-layer": "static-1.53",
  "framework-builder-read-service-client": "static-1.4041",
  "framework-data-schema-quick-fetch": "static-1.6839",
  "persist-promise": "static-1.3745",
  "event-emitter": "static-1.994",
  "bend-plugin-pulse": "static-1.133",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.266",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10159",
  "fsm": "static-1.3777",
  "policy-lib": "static-1.6823",
  "react-tinymce": "static-1.55375",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10222",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54501",
  "tinymce-plugins": "static-1.57615",
  "tinymce-themes": "static-1.56471",
  "growth-onboarding-next-action-components": "static-1.2084",
  "user-context-client": "static-1.4655",
  "nest": "static-1.278",
  "unified-auth-core-lib": "static-1.830",
  "amplitude-session-replay-browser": "static-1.63",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4584",
  "video-embed": "static-1.35937",
  "content-icons-ui": "static-1.2237",
  "social-insights-client-types": "static-1.22231",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4859",
  "integrations-lib": "static-1.16315",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.815",
  "sales-views-client-types": "static-1.4304",
  "InboxConnectUtils": "static-4.14943",
  "meetings-connect-utils-lib": "static-1.7651",
  "calling-orchestration-schema": "static-1.35969",
  "crm-record-cards-service-types": "static-1.3627",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4560",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3088",
  "tinymce-data": "static-1.40586",
  "ui-addon-sales-email": "static-1.5257",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12531",
  "layout-dnd-utils": "static-1.11506",
  "react-codemirror": "static-1.10674",
  "ui-brand-identity-lib": "static-1.15465",
  "NamespacedHubStyle": "static-2.9095",
  "outpost": "static-1.4223",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13730",
  "integrations-tracking-lib": "static-1.5649",
  "native-integrations-shared-strings": "static-1.7828",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10411",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.548",
  "breeze-engine-core": "static-1.93",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68578",
  "layout-data-lib": "static-1.9831",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3062",
  "google-sheets-integration-lib": "static-1.375",
  "microsoft-drive-integration-lib": "static-1.505",
  "slack-ui-library": "static-1.10438",
  "advanced-menus-core": "static-1.15199",
  "advanced-menus-lib": "static-1.12136",
  "ExportDialog": "static-6.10432",
  "ui-memberships-settings-lib": "static-1.34174",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15198",
  "simple-menus-lib": "static-1.16715"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2452",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.473",
  "data-fetching-client": "/data-fetching-client/static-1.9712",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25514",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5637",
  "hs-test-utils": "/hs-test-utils/static-1.8062",
  "hub-http": "/hub-http/static-1.6269",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10076",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18362",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11520",
  "I18n": "/I18n/static-7.1633",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6510",
  "payment-link-components": "/payment-link-components/static-1.23636",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7088",
  "quartz-core": "/quartz-core/static-1.6307",
  "quartz-i18n": "/quartz-i18n/static-1.763",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10255",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5381",
  "rich-text-lib": "/rich-text-lib/static-1.19910",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18062",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5657",
  "UIComponents": "/UIComponents/static-3.8466",
  "foundations-assets": "/foundations-assets/static-1.4916",
  "foundations-components": "/foundations-components/static-1.8021",
  "foundations-theming": "/foundations-theming/static-1.4466",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2182",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1000",
  "quartz-config": "/quartz-config/static-1.866",
  "quartz-routing": "/quartz-routing/static-1.518",
  "quick-fetch": "/quick-fetch/static-1.3954",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fix-in-app-reporter-stuck-start-timestamp.5",
  "rpc-client-utils": "/rpc-client-utils/static-1.4699",
  "sanitize-text": "/sanitize-text/static-1.8189",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4809",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9588",
  "usage-tracker": "/usage-tracker/static-1.7396",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5813",
  "usage-tracker-core": "/usage-tracker-core/static-1.7246",
  "video-components-external": "/video-components-external/static-1.11445",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3436",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3365",
  "quartz-webpack": "/quartz-webpack/static-1.3312",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.166",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7722",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7973",
  "laboratory-lib": "/laboratory-lib/static-3.7202",
  "onboarding-scopes": "/onboarding-scopes/static-1.6508",
  "seat-types-lib": "/seat-types-lib/static-1.125",
  "ui-addon-opt": "/ui-addon-opt/static-4.8409",
  "HeadJS": "/HeadJS/static-2.765",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3173",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.117",
  "ts-schema": "/ts-schema/static-1.4117",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7821",
  "cssUtils": "/cssUtils/static-1.802",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9872",
  "HubStyle": "/HubStyle/static-2.11827",
  "knowledge-content-types": "/knowledge-content-types/static-1.8511",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9933",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11198",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9104",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10252",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4372",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6188",
  "customer-data-properties": "/customer-data-properties/static-1.51733",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18560",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5127",
  "onboarding-tours": "/onboarding-tours/static-1.16692",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8142",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3688",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9106",
  "user-context": "/user-context/static-1.5153",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.839",
  "hubspotter-http": "/hubspotter-http/static-1.4688",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.763",
  "quartz-head": "/quartz-head/static-1.753",
  "quartz-test": "/quartz-test/static-1.763",
  "quartz-tracking": "/quartz-tracking/static-1.467",
  "ui-fonts": "/ui-fonts/static-1.782",
  "usage-tracker-container": "/usage-tracker-container/static-1.7386",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9470",
  "data-token-picker": "/data-token-picker/static-1.16485",
  "FileManagerLib": "/FileManagerLib/static-1.39385",
  "property-translator": "/property-translator/static-1.5445",
  "atom": "/atom/static-1.5121",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "purchase-motions-components": "/purchase-motions-components/static-1.5998",
  "salesImages": "/salesImages/static-1.526",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5504",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1163",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4290",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.31",
  "trellis-assets": "/trellis-assets/static-1.2065",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2949",
  "foundations-theming-base": "/foundations-theming-base/static-1.3451",
  "stylex": "/stylex/static-1.34",
  "interframe": "/interframe/static-3.4805",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5810",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.109",
  "chirp-fetch": "/chirp-fetch/static-1.1934",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4522",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4698",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12500",
  "content-media-compositions": "/content-media-compositions/static-2.16507",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4200",
  "magpie-lib": "/magpie-lib/static-1.5581",
  "magpie-types": "/magpie-types/static-1.5041",
  "media-bridge-lib": "/media-bridge-lib/static-1.19006",
  "video-data-lib": "/video-data-lib/static-1.35103",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3883",
  "superstore": "/superstore/static-1.4806",
  "feedback-loader": "/feedback-loader/static-1.29381",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9087",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8750",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28692",
  "sassPrefix": "/sassPrefix/static-1.157",
  "react-dnd-compat": "/react-dnd-compat/static-1.4660",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2545",
  "navigation-messaging": "/navigation-messaging/static-1.7485",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8218",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9737",
  "crm-message-bus": "/crm-message-bus/static-1.43093",
  "growth-data-modal": "/growth-data-modal/static-1.5499",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4925",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4906",
  "calling-global-api": "/calling-global-api/static-1.64674",
  "calling-internal-common": "/calling-internal-common/static-1.31350",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66056",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58350",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3834",
  "crm-links": "/crm-links/static-1.6350",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4177",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13077",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9403",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8137",
  "external-options-client-types": "/external-options-client-types/static-1.4195",
  "file-manager-components": "/file-manager-components/static-1.23745",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6934",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.211",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3623",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4260",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.678",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3728",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48904",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4003",
  "property-value-citations": "/property-value-citations/static-1.2347",
  "pulse": "/pulse/static-1.630",
  "smart-property-lib": "/smart-property-lib/static-1.7340",
  "tiered-pricing": "/tiered-pricing/static-1.1321",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11036",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3113",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2056",
  "navigation-components": "/navigation-components/static-1.18158",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.758",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7633",
  "ui-universal-auth": "/ui-universal-auth/static-1.9034",
  "batch-promise": "/batch-promise/static-1.1588",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17678",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10074",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5082",
  "audio-components": "/audio-components/static-1.5984",
  "FileManagerCore": "/FileManagerCore/static-1.39244",
  "FileManagerImages": "/FileManagerImages/static-1.36896",
  "video-components": "/video-components/static-1.13447",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1046",
  "purchase-motions-api": "/purchase-motions-api/static-1.6001",
  "signup-constants": "/signup-constants/static-1.18939",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8101",
  "usage-tracker-public": "/usage-tracker-public/static-1.7207",
  "reactive-lib": "/reactive-lib/static-1.770",
  "simple-logging-lib": "/simple-logging-lib/static-1.3097",
  "chatspot-core": "/chatspot-core/static-1.21489",
  "ContentUtils": "/ContentUtils/static-1.68503",
  "copilot-toolkit": "/copilot-toolkit/static-1.11257",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6626",
  "commerce-permissions": "/commerce-permissions/static-1.820",
  "customer-data-tracking": "/customer-data-tracking/static-1.6936",
  "products-iframe-lib": "/products-iframe-lib/static-1.8066",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10458",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2030",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.384",
  "calling-error-reporting": "/calling-error-reporting/static-1.31357",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11082",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6588",
  "self-service-api": "/self-service-api/static-1.10293",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1192",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7295",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9398",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.53",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4041",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6839",
  "persist-promise": "/persist-promise/static-1.3745",
  "event-emitter": "/event-emitter/static-1.994",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.133",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.266",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10159",
  "fsm": "/fsm/static-1.3777",
  "policy-lib": "/policy-lib/static-1.6823",
  "react-tinymce": "/react-tinymce/static-1.55375",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10222",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54501",
  "tinymce-plugins": "/tinymce-plugins/static-1.57615",
  "tinymce-themes": "/tinymce-themes/static-1.56471",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2084",
  "user-context-client": "/user-context-client/static-1.4655",
  "nest": "/nest/static-1.278",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.830",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.63",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4584",
  "video-embed": "/video-embed/static-1.35937",
  "content-icons-ui": "/content-icons-ui/static-1.2237",
  "social-insights-client-types": "/social-insights-client-types/static-1.22231",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4859",
  "integrations-lib": "/integrations-lib/static-1.16315",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.815",
  "sales-views-client-types": "/sales-views-client-types/static-1.4304",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14943",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7651",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35969",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3627",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4560",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3088",
  "tinymce-data": "/tinymce-data/static-1.40586",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5257",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12531",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11506",
  "react-codemirror": "/react-codemirror/static-1.10674",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15465",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9095",
  "outpost": "/outpost/static-1.4223",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13730",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5649",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7828",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10411",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.548",
  "breeze-engine-core": "/breeze-engine-core/static-1.93",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68578",
  "layout-data-lib": "/layout-data-lib/static-1.9831",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3062",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.375",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.505",
  "slack-ui-library": "/slack-ui-library/static-1.10438",
  "advanced-menus-core": "/advanced-menus-core/static-1.15199",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12136",
  "ExportDialog": "/ExportDialog/static-6.10432",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34174",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15198",
  "simple-menus-lib": "/simple-menus-lib/static-1.16715"
}
};
